<template>
  <div id="search" :class="{'active': isExpanded}">
    <div class="popup" v-show="isExpanded" >
      <table class="results" cellpadding="0" cellspacing="0">

        <tr>
          <td colspan="3">
            <input
              id="searchInput"
              autocomplete="off"
              type="text"
              v-model="searchString"
              v-on:blur="closePopup()"
              v-on:keydown.up="prevItem()"
              v-on:keydown.down="nextItem()"
              v-on:keydown.esc="closePopup()"
              v-on:keydown.enter="goToItem()"
              v-on:input="search()"

              >
          </td>
        </tr>
        <tr :key='found.id' v-for="(found,index) in results" :class="{'selected': index === currentItem,
          'kind-f':  found.gender === 'F',
          'kind-m':  found.gender === 'M',
          'kind-k':  found.gender === 'K',
          'kind-u':  found.gender === 'U',
          }">
          <td><a v-on:click.prevent="goToLink(createLink(found))" ><h3 class='model' v-html="getModelName(found)"></h3></a></td>
          <td><a v-on:click.prevent="goToLink(createLink(found))"><div class="photo" v-bind:style="generatePhotoName(found)"></div></a></td>
          <td><div class="icon"></div></td>
        </tr>
        <tr v-if="foundMore > 0">
          <td colspan="2" class="show-more">
            <p><a @click="showFullResults()">pokaż {{ foundMore }} więcej</a></p>
          </td>
        </tr>
      </table>

    </div>
    <div class="icon" v-on:click="toggleExpand">
      <svg version="1.1" viewBox="0 0 544.11 544.11">
        <path d="M528.762,454.723c-2.646-2.666-5.527-4.953-8.546-6.918L387.562,340.662 c61.194-83.813,53.982-202.337-21.634-277.961C282.321-20.9,146.296-20.9,62.7,62.701c-83.597,83.606-83.597,219.623-0.01,303.228 c75.63,75.614,194.151,82.83,277.966,21.639l107.149,132.652c1.963,3.024,4.25,5.897,6.906,8.546 c20.452,20.459,53.61,20.459,74.07,0.009C549.223,508.322,549.223,475.165,528.762,454.723z M98.667,329.944 c-63.758-63.757-63.749-167.504,0.009-231.262c63.767-63.767,167.5-63.767,231.266,0c63.758,63.758,63.768,167.505,0,231.262 C266.184,393.71,162.442,393.71,98.667,329.944z"></path>
      </svg>
    </div>
    <div class="bar" ></div>
  </div>
</template>

<script>

  export default {
    name: 'Search',
    data () {
      return {
        currentItem: -1,
        results: [],
        limitResults: 4,
        foundMore: 0,
        isExpanded: false,
        searchString: ''
      }
    },

    methods: {
      nextItem() {
        if( ( this.currentItem + 1 ) < this.results.length )
        {
          this.currentItem++;
        }
      },
      prevItem() {
        if(this.currentItem > 0)
        {
          this.currentItem--;
        }
      },
      goToLink(address) {

        window.location.href = address;
      },
      goToItem(){
        let selectedItem = this.results[this.currentItem];

          let link = env.baseUrl;
          link += window.translations[(selectedItem.type === 'b') ? 'rt_bike' : 'rt_accessory'];
          link += '/';
          link += selectedItem.internal_name;
          window.location = link;

      },
      search() {
        this.currentItem = -1;
        // talica na znalezione elementy
        let found = [];
        this.results = [];
        this.foundMore = 0;
        // nie ma czego szukać to nie ma wyników
        if (this.searchString.length === 0) return;
        console.log("Searching for: ", this.searchString);

        // szukamy słów zaczynająch się od podanych liter bez względu na wielkość liter
        let regex = new RegExp('\\b' + this.searchString, 'gi')

        // torzymy listę pasujących rowerów
        _.forEach(env.data.bikes, bike => {
          if (bike.name.match(regex) !== null) {
            found.push(bike)
          }
        })
        // dołączamy pasujące akcesoria
        _.forEach(env.data.accessories, acc => {
          if (acc.name.match(regex) !== null) {
            found.push(acc)
          }
        })
        if (found.length > this.limitResults) {
          this.foundMore = found.length - this.limitResults
          found.splice(this.limitResults)
        } else {
          this.foundMore = 0
        }

        this.results = found;
        //console.log('results', this.results);

      },
      // przełącznik panelu
      toggleExpand: function () {
        this.isExpanded = !this.isExpanded
        if(this.isExpanded)  {
          $("#overlay").css('display','block');
          setTimeout( function () {
            document.getElementById('searchInput').focus();
          },200);

        } else {
          $("#overlay").css('display','none');
        }
      },
      closePopup() {
        let that = this;
        setTimeout(function () {
          that.isExpanded = false;
          $("#overlay").css('display','none');
        },200);

      },
      createLink (found) {
        let link = env.baseUrl;
        link += window.translations[(found.type === 'b') ? 'rt_bike' : 'rt_accessory'];
        link += '/';
        link += found.internal_name;

        return link;
      },

      getModelName (found) {
        if (found.type === 'b') {
          return this.$options.filters.bike_name(found.name, found.gender)
        } else return found.name
      },
      /**
       * Ustanawia ścieżkę do pliku ze zdjęciem
       * @param {*} color
       */
      generatePhotoName (found) {
        let color = _.find(found.colors, item=> { return true} );

        let style = 'background-image: url('
        style += env.baseUrl +
          'photos/styles/list/' +
          env.collection +
          '/' + (found.type === 'b' ? 'bikes' : 'accessories') + '/legrand_' +
          color.photo_color.toLowerCase() +
          (color.is_glossy === '1' ? '_polysk' : '_mat') +
          '.png'
        style += ');'
        return style
      }, // generateVariantPhotoName

      showFullResults()
      {
        let link = env.baseUrl;
        link += window.translations['rt_more_results'];
        link += '/' + encodeURI(this.searchString);
        window.location = link;
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Search/Search.vue